import isChartDefinition from './isChartDefinition';
import isDashboardGadget from './isDashboardGadget';
import isIFrame from './isIFrame';
import isImage from './isImage';
import isText from './isText';
import isMetricList from './IsMetricList';
import isVideo from './isVideo';
import isScorecard from './isScorecard';
import isGoal from './isGoal';
import isReportGadget from './isReportGadget';
import isStudioComposite from './isStudioComposite';

const cardTypeCheckers = {
  isChartDefinition,
  isDashboardGadget,
  isReportGadget,
  isIFrame,
  isImage,
  isText,
  isMetricList,
  isVideo,
  isScorecard,
  isGoal,
  isStudioComposite,
};

export default cardTypeCheckers;
